import { render, staticRenderFns } from "./registration-list.vue?vue&type=template&id=5178b1fa"
import script from "./registration-list.vue?vue&type=script&lang=js"
export * from "./registration-list.vue?vue&type=script&lang=js"
import style0 from "./registration-list.vue?vue&type=style&index=0&id=5178b1fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports